import timezoneNames from './timezones';

export default function getPracticeTimezone(practice) {
  const timezone = timezoneNames.find((tz) => tz.value === practice?.timezone);

  if (!timezone) {
    console.warn(
      `Practice timezone "${practice?.timezone}" not found in timezoneNames list. Falling back to Eastern timezone.`
    );
    return timezoneNames.find((tz) => tz.value === 'America/New_York') || timezoneNames[0];
  }

  return timezone;
}
